import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { PopupService } from '@APP/services/popup-service';
import { ConfigService } from '@APP/services/config-service';
import { ManOnWheel } from '../icons/icons';

type OwnDeps = {
  questionsService: QuestionsService;
  popupService: PopupService;
  configService: ConfigService;
};
@requires(QuestionsService.serviceName, PopupService.serviceName, ConfigService.serviceName)
@customElement('survey-complete-popup')
export class SurveyCompletePopup extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
    :host {
      text-align: center;
    }

    .title {
      font-size: 5rem;
      font-weight: 700;
      line-height: 5.4rem;
      margin-bottom: 3.75rem;
    }

    .message {
      font-weight: 500;
    }

    .sub-title {
      font-size: 3rem;
      font-weight: 700;
      margin-bottom: 0;
      text-align: center;
      color: var(--c-text);
    }

    svg {
      max-height: 35.75rem;
      max-width: 30.5rem;
    }

     h2:last-of-type{
       margin-bottom: 2rem;
      }
   `,
    ];
  }

  static get mobileStyles() {
    return [
      css`
      .col-2 svg{
        max-width:22.5rem;
        max-height:22.5rem;
      }
    `,
    ];
  };

  @property({ type: String })
    value: string = '';

  private subs: Function[] = [];

  connectedCallback(): void {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.subs.forEach(f => f());
  }

  renderMobileLayout() {
    const name = this.deps.questionsService.model.getQuestionById('owner_name')?.value as String || '';
    const first_name = name.split(' ')[0];

    return html`
      <div class="grid-container">
       <div class="col-1">
        <h1 class="title">${t('T_Survey_Thanks_1', first_name)}</h1>
       </div>
       <div class="col-2">${ManOnWheel}</div>
       <div class="col-3"><h2 class="sub-title">${t('T_Survey_Thanks_2')}</h2></div>
     </div>
    `;
  }

  renderDesktopLayout() {
    const name = this.deps.questionsService.model.getQuestionById('owner_name')?.value as String || '';
    const first_name = name.split(' ')[0];

    return html`
      <div class="grid-container">
       <div class="col-1">
         <h1 class="title">${t('T_Survey_Thanks_1', first_name)}</h1>
         <h2 class="sub-title">${t('T_Survey_Thanks_2')}</h2>
       </div>
       <div class="col-2">
        ${ManOnWheel}
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
